function ReviewsController( ReviewsService, MetaService, CityConfigService ) {
  "ngInject";

  var vm = this;
  vm.reviews = [];
  vm.loading = false;
  vm.isEndPage = false;
  vm.page = 1;
  vm.cityConfig = CityConfigService;

  vm.getReviews = function () {
    if( vm.isEndPage ) {
      return;
    }

    vm.loading = true;
    ReviewsService.getReviews( vm.page ).then( function ( response ) {
      var responseData = response.data;
      Array.prototype.push.apply( vm.reviews, responseData.data );

      vm.isEndPage = ( responseData.meta.current_page == responseData.meta.last_page );
      ++vm.page;
      vm.loading = false;
    }).catch( function () {
      console.log( 'error occured' );
    });
  }

  var setMetaData = function () {
    MetaService.setMetaTags({
      title: 'Отзывы',
      cityName: CityConfigService.options.city.name
    });
  }

  vm.init = function () {
    setMetaData();
    vm.getReviews();
  }
}

module.exports = ReviewsController;